<template>
  <div class="main-wrapper scroll-y custom-scrollbar with-tabs view-loyalty-signup">

    <page-title :title="'Nowa umowa'" :back="true"></page-title>

    <timeline :labels="stepLabels" :current="signupCurrentStep+1"></timeline>

    <ion-card mode="ios" style="margin: 15px 0">
      <ion-card-header>
        <h6 v-show="title" class="text-up m-0">{{ title }}</h6>
      </ion-card-header>
      <ion-card-content>
        <p v-show="subtitle">{{ subtitle }}</p>

        <!-- forms in steps -->
        <form-loyalty-signup-start v-if="signupCurrentStep === 0"/>
        <form-loyalty-signup-details v-if="signupCurrentStep === 1"/>
        <form-loyalty-signup-sides v-if="signupCurrentStep === 2"/>
        <form-loyalty-signup-terms v-if="signupCurrentStep === 3"/>
        <form-loyalty-signup-confirm v-if="signupCurrentStep === 4"/>
        <form-loyalty-signup-final v-if="signupCurrentStep === 5"/>

      </ion-card-content>
    </ion-card>

  </div>
</template>

<script>
  import { mapState } from 'vuex';
  import PageTitle from '@/components/PageTitle.vue';
  import Timeline from '@/components/Timeline.vue';
  //
  import FormLoyaltySignupStart from '@/forms/loyalty/signup-contract/FormLoyaltySignupStart';
  import FormLoyaltySignupDetails from '@/forms/loyalty/signup-contract/FormLoyaltySignupDetails';
  import FormLoyaltySignupSides from '@/forms/loyalty/signup-contract/FormLoyaltySignupSides';
  import FormLoyaltySignupTerms from '@/forms/loyalty/signup-contract/FormLoyaltySignupTerms';
  import FormLoyaltySignupConfirm from '@/forms/loyalty/signup-contract/FormLoyaltySignupConfirm';
  import FormLoyaltySignupFinal from '@/forms/loyalty/signup-contract/FormLoyaltySignupFinal';

  export default {
    name: 'LoyaltySignup',
    components: {
      PageTitle,
      Timeline,
      FormLoyaltySignupStart,
      FormLoyaltySignupDetails,
      FormLoyaltySignupSides,
      FormLoyaltySignupTerms,
      FormLoyaltySignupConfirm,
      FormLoyaltySignupFinal
    },
    data() {
      return {
        show: false,
        steps: [
          {
            label: 'Start',
            title: 'Start',
            subtitle: 'Witamy w procesie podpisywania umowy Programu lojalnościowego. Podaj numer ID_SFA.'
          },
          {
            label: 'Dane',
            title: 'Dane na umowie',
            subtitle: 'Podaj dane nowej firmy.'
          },
          {
            label: 'Strony',
            title: 'Strony umowy',
            subtitle: 'Podaj dane Właściciela lokalu'
          },
          {
            label: 'Warunki',
            title: 'Warunki umowy',
            subtitle: 'Zapoznaj się z Warunkami dołączenia do Programu Lojalnościowego.'
          },
          {
            label: 'Potwierdź',
            title: 'Potwierdzenie umowy',
            subtitle: 'Wpisz token, który został wysłany na Twój numer.'
          },
          {
            label: 'Koniec',
            title: 'Gratulacje!',
            subtitle: 'Umowa została podpisana prawidłowo. Zostanie teraz poddana automatycznemu sprawdzeniu ' +
                      'poprawności danych. Dokumenty zostaną przysłane dla obu stron w formie elektronicznej.'
          },
        ]
      }
    },
    computed: {
      ...mapState({
        loading: state => state.loyalty.loading,
        signupCurrentStep: state => state.loyalty.signupForm.step,
      }),
      title(){
        return this.steps.length > 0 ? this.steps[this.signupCurrentStep].title : null
      },
      subtitle(){
        return this.steps.length > 0 ? this.steps[this.signupCurrentStep].subtitle : null
      },
      stepLabels(){
        if(this.steps.length > 0) {
          let labels = this.steps.map((item) => {
            return item['label']
          })
          return labels.toString()
        }
      }
    },
    mounted(){
      this.show = true
      this.$store.commit('loyalty/LOYALTY_RESET_SIGNUP')
    }
  }
</script>

<style lang="scss" scoped>
  ion-card-header{
    --background: #ffffff;
  }
  ion-card-content{
    padding: 0 20px 20px 20px;
  }
</style>